import DemandStudioMedicalBillsRow from "./DemandStudioMedicalBillsRow";
import { getMedicalBillRowKey } from "../../utils/medicalBillUtils";
import {
  headerClasses,
  tableClasses,
  tdBaseClasses,
  theadThClasses,
  titleClasses,
  wrapperClasses,
} from "./demandStudioMedicalBillsClasses";

const DemandStudioMedicalBillsTable = ({
  clientId,
  records,
  onFieldChange,
  title = "Medical Bills",
}) => {
  const rows = Array.isArray(records) ? records : [];

  return (
    <div className={wrapperClasses}>
      <div className={headerClasses}>
        <h4 className={titleClasses}>{title}</h4>
      </div>
      <div className="overflow-x-auto">
        <table className={tableClasses}>
          <thead>
            <tr>
              <th className={theadThClasses}>Provider Name</th>
              <th className={theadThClasses}>Total</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td colSpan={2} className={`${tdBaseClasses} text-center text-body`}>
                  No medical bill records.
                </td>
              </tr>
            ) : (
              rows.map((record, index) => (
                <DemandStudioMedicalBillsRow
                  key={getMedicalBillRowKey({ clientId, record, index })}
                  clientId={clientId}
                  records={rows}
                  rowIndex={index}
                  onFieldChange={onFieldChange}
                />
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DemandStudioMedicalBillsTable;
